import * as React from 'react'

import { overrideStyledVariantValue } from '~/utilities/override-styled-variant-value/overrideStyledVariantValue'

import { Button } from '../../button/Button'
import { useBannerContext } from '../BannerContext'

export const BannerRegularButton = (
  props: React.ComponentProps<typeof Button>
) => {
  const { emphasis, size } = useBannerContext()

  const fullWidth = React.useMemo(
    () => overrideStyledVariantValue(size, (s) => s === 'sm'),
    [size]
  )

  return (
    <Button
      size={size}
      fullWidth={fullWidth}
      theme={emphasis === 'bold' ? 'neutral' : 'primary'}
      {...props}
    />
  )
}

BannerRegularButton.displayName = 'BannerRegularButton'
